import React from "react";
import { Helmet } from "react-helmet";

const SEOHead = ({ 
  title = "Consultant Travaux et Rénovation Eure-et-Loir | CTB28",
  description = "Consultant travaux et rénovation en Eure-et-Loir (28). Expert conseil en bâtiment depuis plus de 40 ans : études de faisabilité, suivi de chantier, conseil matériaux, lecture de devis.",
  keywords = "consultant travaux Eure-et-Loir, rénovation 28, conseil bâtiment 28, suivi de chantier, étude faisabilité, conseil matériaux, lecture de devis, CTB28",
  currentUrl = "https://ctb28.fr"
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "ctb28.fr - Consultant Travaux et Rénovation",
    "description": description,
    "url": currentUrl,
    "telephone": "+33612345678",
    "email": "f.merrigiolli@conseil-batiment.fr",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Chartres",
      "addressRegion": "Eure-et-Loir",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "45.764043",
      "longitude": "4.835659"
    },
    "founder": {
      "@type": "Person",
      "name": "ctb28.fr",
      "jobTitle": "Consultant en Bâtiment",
      "worksFor": {
        "@type": "Organization",
        "name": "ctb28.fr Conseil Bâtiment"
      }
    },
    "serviceType": [
      "Conseil en bâtiment",
      "Rénovation",
      "Construction",
      "Aménagement",
      "Rénovation énergétique",
      "Extension de maison",
      "Diagnostic bâtiment"
    ],
    "areaServed": {
      "@type": "Place",
      "name": "Eure-et-Loir (28) et Île-de-France"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de conseil en bâtiment",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Étude de faisabilité",
            "description": "Analyse complète de votre projet : contraintes techniques, réglementaires et budgétaires"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Conseil en matériaux",
            "description": "Sélection des matériaux optimaux selon vos besoins, budget et contraintes techniques"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Suivi de chantier",
            "description": "Accompagnement et contrôle qualité tout au long de la réalisation de vos travaux"
          }
        }
      ]
    },
    "review": {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Clients satisfaits"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "50",
      "bestRating": "5"
    }
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      
      {/* Additional SEO tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="website" />
      
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEOHead;